import sdkProvider from "./sdkProvider";

const activateMvtFeature = async featureName => {
  const sdk = await sdkProvider("features");
  await sdk.onReady();

  sdk.getFeature(featureName).isEnabled();
};

export default activateMvtFeature;
